import { HttpAdapter } from "../../../main/adapters/HttpAdapter";

export class ESocialRemovePeriodsService {
    HttpAdapter = new HttpAdapter();
    baseUrlESocial = `${publicSettings.aws.baseUrls.dataSources}/esocial`;

    constructor() {}

    async exec({ companyId, periods } = {}) {
        try {
            await this.HttpAdapter.call(
                `${this.baseUrlESocial}/remove-by-periods`,
                { companyId, periods }
            );

            return true;
        } catch (err) {
            console.log("err", err);
            return false;
        }
    }
}
